import { render, staticRenderFns } from "./MessageEditor.vue?vue&type=template&id=12d59e1c&scoped=true"
import script from "./MessageEditor.vue?vue&type=script&lang=ts"
export * from "./MessageEditor.vue?vue&type=script&lang=ts"
import style0 from "./MessageEditor.vue?vue&type=style&index=0&id=12d59e1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d59e1c",
  null
  
)

export default component.exports